"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newTrackPageView = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _routeMatcher = require("route-matcher");

var _actions = require("./actions.js");

var newTrackPageView = function newTrackPageView(getDataLayer, routesTrackingData, store, document) {
  var nextReferrer = document.referrer;
  var routesWithMatchers = Object.entries(routesTrackingData).map(function (_ref) {
    var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
        path = _ref2[0],
        pageData = _ref2[1];

    return {
      matcher: (0, _routeMatcher.routeMatcher)(path),
      pageData: pageData
    };
  });
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(location) {
      var _ref4,
          variant,
          referrer,
          route,
          pageData,
          matcher,
          page,
          _args = arguments;

      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref4 = _args.length > 1 && _args[1] !== undefined ? _args[1] : {}, variant = _ref4.variant;
              referrer = nextReferrer;
              nextReferrer = document.location.href;
              route = routesWithMatchers.find(function (_ref5) {
                var matcher = _ref5.matcher;
                return matcher.parse(location.pathname) !== null;
              });

              if (route) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return");

            case 6:
              pageData = route.pageData, matcher = route.matcher;
              page = typeof pageData === "function" ? pageData(matcher.parse(location.pathname)) : pageData;

              if (!page) {
                _context.next = 11;
                break;
              }

              _context.next = 11;
              return store.dispatch((0, _actions.trackPageView)(getDataLayer, page, variant, referrer));

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }();
};

exports.newTrackPageView = newTrackPageView;